import React from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { useField, useFormikContext } from 'formik';
import { FormHelperText } from '@mui/material';

interface MultiSelectCheckboxProps {
  name: string;
  options: { key: string; value: string }[];
  selectedValues: string[];
  onChange?: (newSelectedValues: string) => void;
  disabled?: boolean;
}

function MultiSelectCheckbox({
  name,
  options,
  selectedValues,
  onChange,
  disabled = false,
}: MultiSelectCheckboxProps): JSX.Element {
  const [field, meta] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : '';
  const { setFieldValue } = useFormikContext();
  const handleCheckboxChange = (value: string) => {
    const index = (selectedValues || []).indexOf(value as string);
    if (index === -1) {
      setFieldValue(name, [...field.value, value]);
    } else {
      setFieldValue(
        name,
        field.value.filter((item: any) => item != (value as string))
      );
    }
  };

  return (
    <FormGroup>
      {options.map((option) => (
        <FormControlLabel
          key={option.key}
          value={option.key}
          control={
            <Checkbox
              disabled={disabled}
              onChange={() => (onChange ? onChange(option.key) : handleCheckboxChange(option.key))}
              checked={(selectedValues || []).includes(option.key)}
            />
          }
          label={option.value}
        />
      ))}
      {errorText && (
        <FormHelperText error sx={{ marginLeft: 'unset' }}>
          {errorText}
        </FormHelperText>
      )}
    </FormGroup>
  );
}

export default MultiSelectCheckbox;
